$(window).on("load", function () {

    // First accordion open (optional)
    $(".accordion-box:first .content-sectionaccordion").show();
    $(".accordion-box:first .plusicon").hide();
    $(".accordion-box:first .minusicon").show();

});

// Event delegation
$(document).on("click", ".accordionheading-section", function () {

    let $box = $(this).closest(".accordion-box");
    let $content = $box.find(".content-sectionaccordion");

    if ($content.is(":visible")) {

        $content.stop(true, true).slideUp(300);
        $box.find(".plusicon").show();
        $box.find(".minusicon").hide();

    } else {

        $(".content-sectionaccordion").stop(true, true).slideUp(300);
        $(".plusicon").show();
        $(".minusicon").hide();

        $content.stop(true, true).slideDown(300);
        $box.find(".plusicon").hide();
        $box.find(".minusicon").show();
    }

});    


$(document).ready(function () {
    $('.marquee-slider').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 3000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        variableWidth: true,
        swipe: false,
        draggable: false,
        touchMove: false
    });
});

document.addEventListener("DOMContentLoaded", function () {

  // const unitsSold = document.querySelector(".unitsold-number strong");
  // if (unitsSold) {
  //   const randomK = Math.floor(Math.random() * 21) + 410; // 410K - 430K
  //   unitsSold.textContent = randomK + "K+";
  // }

 const viewing = document.querySelector(".viewing-number strong");
  if (viewing) {
    const randomView = Math.floor(Math.random() * (1500 - 100 + 1)) + 100; // 100 - 1500
    viewing.textContent = randomView.toLocaleString() + "+"; // e.g. 1,234+
  }

});